import React from "react"

import SelectButton from '../../form_sections/SelectButton'

class LocationFilter extends React.Component {
  descriptionText() {
    if (this.props.locals_only) {
      if (this.props.filter === true) {
        return 'Matches near your area only.'
      }
      return 'Only nearby members can contact you.'
    }

    if (this.props.filter === true) {
      return 'Matches from anywhere in the world.'
    }

    return 'Members worldwide can contact you.'
  }

  buttonText(localOnly) {
    return localOnly ? 'Near me' : 'Anywhere'
  }

  render() {
    return (
      <section className="matchFiltersModal__card">
        <h3 className="matchFiltersModal__sectionTitle">Location</h3>
        <p className="matchFiltersModal__sectionHint">{this.descriptionText()}</p>
        <div className="matchFiltersModal__chipGroup matchFiltersModal__chipGroup--grid">
          <SelectButton
            morphism
            selected={this.props.locals_only}
            onClick={() => this.props.updateLocation(true)}
            buttonText={this.buttonText(true)}
          />
          <SelectButton
            morphism
            selected={!this.props.locals_only}
            onClick={() => this.props.updateLocation(false)}
            buttonText={this.buttonText(false)}
          />
        </div>
      </section>
    )
  }
}

export default LocationFilter
